export var env={
  showNewEditor:window.location.href.match(/7127/) ? false : false,
}